export default __webpack_public_path__ + "static/media/launch-box-icon.c1564075.svg";